/*
{
    'name': 'Common Sense',
    'altIdDomain': 'commonsense.org/uuid',
    'ui': true,
    'mediaType': 'text/html',
    'uriTemplate': 'https://www.commonsensemedia.org/contentlink/{0}',
  }
 */



export const urlMapping = [
  {
    "name": "Adoro Cinema Series",
    "altIdDomain": "adorocinema.com/series",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.adorocinema.com/series/serie-{0}/"
  },
  {
    "name": "Adult Film Database",
    "altIdDomain": "adultfilmdatabase.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.adultfilmdatabase.com/video.cfm?videoid={0}"
  },
  {
    "name": "American Film Institute",
    "altIdDomain": "afidb.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://catalog.afi.com/Catalog/moviedetails/{0}"
  },
  {
    "name": "Africultures",
    "altIdDomain": "africultures.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://africultures.com/films/?no={0}"
  },
  {
    "name": "Allcinema",
    "altIdDomain": "allcinema.net",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.allcinema.net/prog/show_c.php?num_c={0}"
  },
  {
    "name": "AllMovie",
    "altIdDomain": "allmovie.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.allmovie.com/movie/{0}"
  },
  {
    "name": "AlloCine Film",
    "altIdDomain": "allocine.fr/film",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.allocine.fr/film/fichefilm_gen_cfilm={0}.html"
  },
  {
    "name": "AlloCine Series",
    "altIdDomain": "allocine.fr/series",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.allocine.fr/series/ficheserie_gen_cserie={0}.html"
  },
  {
    "name": "ALTBalaji Media",
    "altIdDomain": "altbalaji.com/media",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.altbalaji.com/media/{0}"
  },
  {
    "name": "ALTBalaji Show",
    "altIdDomain": "altbalaji.com/show",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.altbalaji.com/show/{0}"
  },
  {
    "name": "Amazon.co.jp",
    "altIdDomain": "amazon.co.jp",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.amazon.co.jp/%E9%A6%96%E9%A0%98%E3%81%AE%E9%81%93-DVD-%E5%B0%8F%E6%B2%A2%E4%BB%81%E5%BF%97/dp/{0}"
  },
  {
    "name": "Amazon ASIN",
    "altIdDomain": "amazon.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.amazon.com/dp/{0}"
  },
  {
    "name": "Academy of Motion Picture Arts and Sciences",
    "altIdDomain": "ampas.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://academycollection.org/web/arena/search#/entity/academy/{0}"
  },
  {
    "name": "Anime News Network",
    "altIdDomain": "animenewsnetwork.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.animenewsnetwork.com/encyclopedia/anime.php?id={0}"
  },
  {
    "name": "@Movies",
    "altIdDomain": "atmovies.com.tw",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://app2.atmovies.com.tw/film/{0}"
  },
  {
    "name": "Barnes & Noble",
    "altIdDomain": "barnesandnoble.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.barnesandnoble.com/w/{0}"
  },
  {
    "name": "BB Media",
    "altIdDomain": "bb-media.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://streamdiscover.com/title/{0}"
  },
  {
    "name": "BBC",
    "altIdDomain": "bbc.co.uk/pid",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.bbc.co.uk/programmes/{0}"
  },
  {
    "name": "The Big Cartoon Database",
    "altIdDomain": "bcdb.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.bcdb.com/bcdb/cartoon.cgi?film={0}"
  },
  {
    "name": "Beyazperde.com Diziler",
    "altIdDomain": "beyazperde.com/diziler",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.beyazperde.com/diziler/dizi-{0}/"
  },
  {
    "name": "Beyazperde.com Filmler",
    "altIdDomain": "beyazperde.com/filmler",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.beyazperde.com/filmler/film-{0}/"
  },
  {
    "name": "British Film Institute",
    "altIdDomain": "bfi.org.uk",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://collections-search.bfi.org.uk/web/Details/ChoiceFilmWorks/{0}"
  },
  {
    "name": "Bangla Movie Database",
    "altIdDomain": "bmdb.com.bd",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.bmdb.com.bd/movie/{0}/"
  },
  {
    "name": "Bibliotheque nationale de France",
    "altIdDomain": "bnf.fr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://data.bnf.fr/fr/{0}/"
  },
  {
    "name": "Bollywood Hungama",
    "altIdDomain": "bollywoodhungama.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.bollywoodhungama.com/?p={0}"
  },
  {
    "name": "Box Office Mojo",
    "altIdDomain": "boxofficemojo.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.boxofficemojo.com/movies/?id={0}.htm"
  },
  {
    "name": "Agency for Cultural Affairs",
    "altIdDomain": "bunka.go.jp",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://mediaarts-db.bunka.go.jp/an/anime_series/{0}"
  },
  {
    "name": "Buzzsprout",
    "altIdDomain": "buzzsprout.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.buzzsprout.com/{0}"
  },
  {
    "name": "CBO Box-Office",
    "altIdDomain": "cbo-boxoffice.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://cbo-boxoffice.com/v4/page000.php3?inc=fichemov.php3&fid={0}"
  },
  {
    "name": "Chiloka",
    "altIdDomain": "chiloka.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://chiloka.com/movie/{0}"
  },
  {
    "name": "CINE AR TV",
    "altIdDomain": "cine.ar/movie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://tv.cine.ar/movie/{0}/"
  },
  {
    "name": "Cine.gr",
    "altIdDomain": "cine.gr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://cine.gr/film.asp?id={0}"
  },
  {
    "name": "Cine21",
    "altIdDomain": "cine21.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.cine21.com/movie/info/?movie_id={0}"
  },
  {
    "name": "CineFox",
    "altIdDomain": "cinefox.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://cinefox.com/vod/view?product_seq={0}"
  },
  {
    "name": "cinema.de",
    "altIdDomain": "cinema.de",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.cinema.de/{0}"
  },
  {
    "name": "cinema.ptgate.pt",
    "altIdDomain": "cinema.ptgate.pt",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://cinema.ptgate.pt/filmes/{0}"
  },
  {
    "name": "Cinemagia",
    "altIdDomain": "cinemagia.ro",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.cinemagia.ro/movie.php?movie_id={0}"
  },
  {
    "name": "Cinema Paradiso",
    "altIdDomain": "cinemaparadiso.co.uk",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.cinemaparadiso.co.uk/rentals/{0}.html"
  },
  {
    "name": "Cinemateca Brasileira",
    "altIdDomain": "cinemateca.gov.br",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://bases.cinemateca.gov.br/cgi-bin/wxis.exe/iah/?IsisScript=iah/iah.xis&base=FILMOGRAFIA&lang=P&nextAction=search&exprSearch=ID={0}&format=detailed.pft"
  },
  {
    "name": "Cinematheque",
    "altIdDomain": "cinematheque.fr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://cinema.encyclopedie.films.bifi.fr/index.php?pk={0}"
  },
  {
    "name": "Cinematheque QC",
    "altIdDomain": "cinematheque.qc.ca",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://collections.cinematheque.qc.ca/recherche/oeuvres/fiche/{0}"
  },
  {
    "name": "cinematoday.jp",
    "altIdDomain": "cinematoday.jp",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.cinematoday.jp/movie/{0}"
  },
  {
    "name": "Cinematografo.it",
    "altIdDomain": "cinematografo.it",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.cinematografo.it/pls/cinematografo/consultazione.redirect?sch={0}"
  },
  {
    "name": "CineNacional.com",
    "altIdDomain": "cinenacional.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://cinenacional.com/pelicula/{0}"
  },
  {
    "name": "CineSerie Movies",
    "altIdDomain": "cineserie.com/movies",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.cineserie.com/movies/{0}/"
  },
  {
    "name": "CineSerie Series",
    "altIdDomain": "cineserie.com/series",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.cineserie.com/series/{0}/"
  },
  {
    "name": "Cinestaan",
    "altIdDomain": "cinestaan.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.cinestaan.com/movies/-{0}"
  },
  {
    "name": "Cineuropa",
    "altIdDomain": "cineuropa.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://cineuropa.org/en/film/{0}/"
  },
  {
    "name": "Cineuropa",
    "altIdDomain": "cineuropa.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://cineuropa.org/fr/film/{0}/"
  },
  {
    "name": "Cineuropa",
    "altIdDomain": "cineuropa.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://cineuropa.org/es/film/{0}/"
  },
  {
    "name": "Cineuropa",
    "altIdDomain": "cineuropa.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://cineuropa.org/it/film/{0}/"
  },
  {
    "name": "CNC",
    "altIdDomain": "cnc.fr/visa",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.cnc.fr/professionnels/visas-et-classification/{0}"
  },
  {
    "name": "Colonial Film",
    "altIdDomain": "colonialfilm.org.uk",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.colonialfilm.org.uk/node/{0}"
  },
  {
    "name": "Comcast",
    "altIdDomain": "comcast.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.xfinity.com/stream/entity/{0}"
  },
  {
    "name": "Common Sense",
    "altIdDomain": "commonsense.org/uuid",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.commonsensemedia.org/contentlink/{0}"
  },
  {
    "name": "Cesko-Slovenska filmova databaze",
    "altIdDomain": "csfd.cz",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.csfd.cz/film/{0}"
  },
  {
    "name": "DFI",
    "altIdDomain": "dfi.dk/movie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.dfi.dk/viden-om-film/filmdatabasen/film/{0}"
  },
  {
    "name": "DFI",
    "altIdDomain": "dfi.dk/movie",
    "ui": false,
    "mediaType": "application/xml",
    "uriTemplate": "https://nationalfilmografien.service.dfi.dk/movie.svc/{0}"
  },
  {
    "name": "DFI",
    "altIdDomain": "dfi.dk/movie",
    "ui": false,
    "mediaType": "application/json",
    "uriTemplate": "https://nationalfilmografien.service.dfi.dk/movie.svc/json/{0}"
  },
  {
    "name": "Chinese Movie Database",
    "altIdDomain": "dianying.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.dianying.com/en/title/{0}"
  },
  {
    "name": "Diziler",
    "altIdDomain": "diziler.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.diziler.com/dizi/{0}"
  },
  {
    "name": "DMM",
    "altIdDomain": "dmm.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.dmm.com/rental/-/detail/=/cid={0}/"
  },
  {
    "name": "Taiwan Docs",
    "altIdDomain": "docs.tfi.org.tw",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://docs.tfi.org.tw/en/film/{0}"
  },
  {
    "name": "DreamWiz",
    "altIdDomain": "dreamwiz.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.dreamwiz.com/VIEW/MOVIE/{0}"
  },
  {
    "name": "edb.co.il",
    "altIdDomain": "edb.co.il",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.edb.co.il/title/{0}/"
  },
  {
    "name": "Eesti Filmi Andmebaas",
    "altIdDomain": "efis.ee",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.efis.ee/et/filmiliigid/film/id/{0}"
  },
  {
    "name": "Rahvusarhiiv",
    "altIdDomain": "eha.ee",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.eha.ee/fa/public//index.php?act=search_detail&a_id=3091&mod=3&lang=en"
  },
  {
    "name": "eiga.com",
    "altIdDomain": "eiga.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://eiga.com/movie/{0}/"
  },
  {
    "name": "elcinema.com",
    "altIdDomain": "elcinema.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.elcinema.com/work/{0}/"
  },
  {
    "name": "Elonet",
    "altIdDomain": "elonet.fi",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.elonet.fi/fi/elokuva/{0}"
  },
  {
    "name": "Encyclocine",
    "altIdDomain": "encyclocine.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.encyclocine.com/index.html?menu=72608&film={0}"
  },
  {
    "name": "epguides",
    "altIdDomain": "epguides.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://epguides.com/{0}"
  },
  {
    "name": "Fabric Origin",
    "altIdDomain": "fabricorigin.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://fabricorigin.com/{0}"
  },
  {
    "name": "Fabric Origin Movie",
    "altIdDomain": "fabricorigin.com/movie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://portal.fabricorigin.com/movie/{0}"
  },
  {
    "name": "Fabric Origin Show",
    "altIdDomain": "fabricorigin.com/show",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://portal.fabricorigin.com/show/{0}"
  },
  {
    "name": "Fandango",
    "altIdDomain": "fandango.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.fandango.com/whatever-{0}/movie-overview"
  },
  {
    "name": "film-documentaire.fr",
    "altIdDomain": "film-documentaire.fr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.film-documentaire.fr/4DACTION/w_fiche_film/{0}"
  },
  {
    "name": "Film Affinity",
    "altIdDomain": "filmaffinity.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmaffinity.com/es/film{0}.html"
  },
  {
    "name": "Film Affinity",
    "altIdDomain": "filmaffinity.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmaffinity.com/en/film{0}.html"
  },
  {
    "name": "Filmarks Movie ID",
    "altIdDomain": "filmarks.com/movies",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://filmarks.com/movies/{0}"
  },
  {
    "name": "Film Indonesia",
    "altIdDomain": "filmindonesia.or.id",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://filmindonesia.or.id/movie/title/{0}"
  },
  {
    "name": "Film Italia",
    "altIdDomain": "filmitalia.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmitalia.org/p.aspx?t=film&l=it&did={0}"
  },
  {
    "name": "Film Italia",
    "altIdDomain": "filmitalia.org",
    "ui": false,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmitalia.org/p.aspx?t=film&l=en&did={0}"
  },
  {
    "name": "FilmPolski.pl",
    "altIdDomain": "filmpolski.pl",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmpolski.pl/fp/index.php/{0}"
  },
  {
    "name": "FILMSTARTS Kritiken",
    "altIdDomain": "filmstarts.de/kritiken",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmstarts.de/kritiken/{0}.html"
  },
  {
    "name": "FILMSTARTS Serien",
    "altIdDomain": "filmstarts.de/serien",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmstarts.de/serien/{0}.html"
  },
  {
    "name": "FilmVandaag Film",
    "altIdDomain": "filmvandaag.nl/film",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmvandaag.nl/film/{0}"
  },
  {
    "name": "FilmVandaag Serie",
    "altIdDomain": "filmvandaag.nl/serie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmvandaag.nl/serie/{0}"
  },
  {
    "name": "FilmWeb.no",
    "altIdDomain": "filmweb.no",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmweb.no/film/article{0}.ece"
  },
  {
    "name": "Filmweb",
    "altIdDomain": "filmweb.pl",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmweb.pl/Film?id={0}"
  },
  {
    "name": "First Century of Cinema",
    "altIdDomain": "firstcenturyofcinema.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://firstcenturyofcinema.com/details_page.aspx?RequestId={0}"
  },
  {
    "name": "Georgian National Filmography",
    "altIdDomain": "geocinema.ge",
    "ui": false,
    "mediaType": "text/html",
    "uriTemplate": "http://geocinema.ge//ka/movies/{0}"
  },
  {
    "name": "Georgian National Filmography",
    "altIdDomain": "geocinema.ge",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://geocinema.ge//en/movies/{0}"
  },
  {
    "name": "German Films",
    "altIdDomain": "german-films.de",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.german-films.de/film-archive/browse-archive/view/detail/film/{0}/index.html"
  },
  {
    "name": "Giant Screen Cinema Association",
    "altIdDomain": "giantscreencinema.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.giantscreencinema.com/Films/Film-Database/FilmDatabaseDetailView/movieid/{0}"
  },
  {
    "name": "Hulu Japan",
    "altIdDomain": "happyon.jp",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.happyon.jp/watch/{0}"
  },
  {
    "name": "Oceanic Sites at the University of Hawai‘i",
    "altIdDomain": "hawaii.edu/oceanic",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.hawaii.edu/oceanic/film/filmdb/{0}.html"
  },
  {
    "name": "Hong Kong Cinemagic",
    "altIdDomain": "hkcinemagic.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.hkcinemagic.com/en/movie.asp?id={0}"
  },
  {
    "name": "HKMDB",
    "altIdDomain": "hkmdb.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://hkmdb.com/db/movies/view.mhtml?id={0}"
  },
  {
    "name": "HMV & Books Online",
    "altIdDomain": "hmv.co.jp",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.hmv.co.jp/en/productitemstock/stock/{0}"
  },
  {
    "name": "Hoopla",
    "altIdDomain": "hoopladigital.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.hoopladigital.com/title/{0}"
  },
  {
    "name": "Hulu Movies",
    "altIdDomain": "hulu.com/movie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.hulu.com/movie/{0}"
  },
  {
    "name": "Hulu Series",
    "altIdDomain": "hulu.com/series",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.hulu.com/series/{0}"
  },
  {
    "name": "Irish Film Institute",
    "altIdDomain": "ifi.ie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://ifi.ie/ifiifilmdirectory/international-film?id={0}"
  },
  {
    "name": "Irish Film & Television Network",
    "altIdDomain": "iftn.ie/filmography",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.iftn.ie/filmography/feature/?act1=record&aid=70&rid={0}&tpl=filmography_dets"
  },
  {
    "name": "IMDB",
    "altIdDomain": "imdb.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.imdb.com/title/{0}"
  },
  {
    "name": "INA",
    "altIdDomain": "ina.fr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.ina.fr/video/{0}"
  },
  {
    "name": "indiancine.ma",
    "altIdDomain": "indiancine.ma",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://indiancine.ma/{0}"
  },
  {
    "name": "India Times",
    "altIdDomain": "indiatimes.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://timesofindia.indiatimes.com/entertainment/hindi/movie-reviews/movie-review/{0}.cms"
  },
  {
    "name": "infoicaa.mecd.es",
    "altIdDomain": "infoicaa.mecd.es",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://infoicaa.mecd.es/CatalogoICAA/Peliculas/Detalle?pelicula={0}"
  },
  {
    "name": "Irish Film Database",
    "altIdDomain": "irishfilmdb.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://irishfilmdb.com/movies/{0}/"
  },
  {
    "name": "ISAN",
    "altIdDomain": "isan.org/serial",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.isan.org/lookup/{0}"
  },
  {
    "name": "ITV Studios",
    "altIdDomain": "itvstudios.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.itvstudios.com/catalogue/{0}"
  },
  {
    "name": "Japanese Film Database",
    "altIdDomain": "jfdb.jp",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://jfdb.jp/en/title/{0}"
  },
  {
    "name": "Kanopy",
    "altIdDomain": "kanopy.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.kanopy.com/node/{0}/"
  },
  {
    "name": "Kinenote",
    "altIdDomain": "kinenote.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.kinenote.com/main/public/cinema/detail.aspx?cinema_id={0}"
  },
  {
    "name": "Kinobox.cz",
    "altIdDomain": "kinobox.cz",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.kinobox.cz/film/{0}"
  },
  {
    "name": "Kinopoisk",
    "altIdDomain": "kinopoisk.ru",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.kinopoisk.ru/film/{0}/"
  },
  {
    "name": "KMDb",
    "altIdDomain": "kmdb.or.kr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.kmdb.or.kr/db/kor/detail/movie/{0}"
  },
  {
    "name": "KMDb",
    "altIdDomain": "kmdb.or.kr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.kmdb.or.kr/eng/db/kor/detail/movie/{0}"
  },
  {
    "name": "Korea Media Rating Board",
    "altIdDomain": "kmrb.or.kr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.kmrb.or.kr/kor/CMS/TotalSearch/gradeResultView.do?mCode=MN132&rcv_no={0}"
  },
  {
    "name": "Korean Film Archive",
    "altIdDomain": "koreafilm.or.kr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.koreafilm.or.kr/library/search/video/{0}"
  },
  {
    "name": "koreanfilm.or.kr",
    "altIdDomain": "koreanfilm.or.kr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.koreanfilm.or.kr/eng/films/index/filmsView.jsp?movieCd={0}"
  },
  {
    "name": "kukla.tv",
    "altIdDomain": "kukla.tv",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://kukla.tv/story.html"
  },
  {
    "name": "Kvikmyndir.is",
    "altIdDomain": "kvikmyndir.is",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://kvikmyndir.is/mynd/?id={0}"
  },
  {
    "name": "Learning on Screen",
    "altIdDomain": "learningonscreen.ac.uk",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://bufvc.ac.uk/tvandradio/trilt/index.php/prog/{0}"
  },
  {
    "name": "Lens Nepal",
    "altIdDomain": "lensnepal.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.lensnepal.com/movie/{0}.html"
  },
  {
    "name": "Letterboxd",
    "altIdDomain": "letterboxd.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://letterboxd.com/film/{0}"
  },
  {
    "name": "Library of Congress",
    "altIdDomain": "loc.gov/lccn",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://lccn.loc.gov/{0}"
  },
  {
    "name": "Lost Films",
    "altIdDomain": "lost-films.eu",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.lost-films.eu/films/show/id/{0}"
  },
  {
    "name": "Lumiere",
    "altIdDomain": "lumiere.obs.coe.int",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://lumiere.obs.coe.int/web/film_info/?id={0}"
  },
  {
    "name": "Luminate Data",
    "altIdDomain": "luminatedata.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://filmandtv.luminatedata.com/login.php"
  },
  {
    "name": "Luminate Data",
    "altIdDomain": "luminatedata.com/SeasonID",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://filmandtv.luminatedata.com/login.php"
  },
  {
    "name": "Luminate Data",
    "altIdDomain": "luminatedata.com/SeriesID",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://filmandtv.luminatedata.com/login.php"
  },
  {
    "name": "M3db",
    "altIdDomain": "m3db.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://m3db.com/film/{0}"
  },
  {
    "name": "Malayala Chalachithram",
    "altIdDomain": "malayalachalachithram.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.malayalachalachithram.com/movie.php?i={0}"
  },
  {
    "name": "Maoyan Film ID",
    "altIdDomain": "maoyan.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://maoyan.com/films/{0}"
  },
  {
    "name": "Media Art Database (Development Version)",
    "altIdDomain": "mediaarts-db.bunka.go.jp",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://mediaarts-db.bunka.go.jp/an/anime_series/{0}"
  },
  {
    "name": "Daum",
    "altIdDomain": "movie.daum.net",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://movie.daum.net/moviedb/main?movieId={0}"
  },
  {
    "name": "douban.com",
    "altIdDomain": "movie.douban.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://movie.douban.com/subject/{0}/"
  },
  {
    "name": "Naver",
    "altIdDomain": "movie.naver.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://movie.naver.com/movie/bi/mi/basic.nhn?code={0}"
  },
  {
    "name": "Movie Buff",
    "altIdDomain": "moviebuff.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.moviebuff.com/{0}"
  },
  {
    "name": "MovieMeter.nl",
    "altIdDomain": "moviemeter.nl",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.moviemeter.nl/film/{0}"
  },
  {
    "name": "MovieMeter Season",
    "altIdDomain": "moviemeter.nl/season",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.moviemeter.nl/series/season/{0}"
  },
  {
    "name": "MovieMeter Show",
    "altIdDomain": "moviemeter.nl/show",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.moviemeter.nl/series/show/{0}"
  },
  {
    "name": "Moviepilot Movies",
    "altIdDomain": "moviepilot.de/movies/",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.moviepilot.de/movies/{0}"
  },
  {
    "name": "Moviepilot Series",
    "altIdDomain": "moviepilot.de/serie/",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.moviepilot.de/serie/{0}"
  },
  {
    "name": "Movieplayer.it Film",
    "altIdDomain": "movieplayer.it/film",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://movieplayer.it/film/wd_{0}/"
  },
  {
    "name": "Movieplayer.it Series",
    "altIdDomain": "movieplayer.it/serietv",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://movieplayer.it/serietv/wd_{0}/"
  },
  {
    "name": "Yahoo! Japan",
    "altIdDomain": "movies.yahoo.co.jp",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://movies.yahoo.co.jp/movie/{0}/"
  },
  {
    "name": "Yahoo! Taiwan",
    "altIdDomain": "movies.yahoo.com.tw",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://movies.yahoo.com.tw/movieinfo_main.html/id={0}"
  },
  {
    "name": "MSI",
    "altIdDomain": "msidb.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://en.msidb.org/m.php?{0}"
  },
  {
    "name": "MSI",
    "altIdDomain": "msidb.org",
    "ui": false,
    "mediaType": "text/html",
    "uriTemplate": "https://ml.msidb.org/m.php?{0}"
  },
  {
    "name": "Mubi",
    "altIdDomain": "mubi.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://mubi.com/films/{0}"
  },
  {
    "name": "My Anime List",
    "altIdDomain": "myanimelist.net",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://myanimelist.net/anime/{0}"
  },
  {
    "name": "My Drama List",
    "altIdDomain": "mydramalist.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://mydramalist.com/{0}"
  },
  {
    "name": "Nemzeti Audiovizuális Archívum",
    "altIdDomain": "nava.hu",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://nava.hu/id/{0}/"
  },
  {
    "name": "Norsk filmografi",
    "altIdDomain": "nb.no",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.nb.no/filmografi/show?id={0}"
  },
  {
    "name": "The Neighborhood Archive",
    "altIdDomain": "neighborhoodarchive.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.neighborhoodarchive.com/mrn/episodes/{0}/index.html"
  },
  {
    "name": "NetFlix",
    "altIdDomain": "netflix.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.netflix.com/title/{0}"
  },
  {
    "name": "Norwegian Film Institute",
    "altIdDomain": "nfi.no",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.nfi.no/film?id={0}"
  },
  {
    "name": "National Film and Sound Archive of Australia",
    "altIdDomain": "nfsa.gov.au",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://colsearch.nfsa.gov.au/nfsa/search/display/display.w3p;adv=no;page=0;query=Id%3A{0};rec=0;resCount=1"
  },
  {
    "name": "New Zealand Archive of Film Television and Sound",
    "altIdDomain": "ngataonga.org.nz",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://ngataonga.org.nz/collections/catalogue/catalogue-item?record_id={0}"
  },
  {
    "name": "NZ on Screen",
    "altIdDomain": "nzonscreen.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://ngataonga.org.nz/collections/catalogue/catalogue-item?record_id={0}"
  },
  {
    "name": "Online-Filmdatenbank",
    "altIdDomain": "ofdb.de",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://ssl.ofdb.de/film/{0},"
  },
  {
    "name": "Opera On Video",
    "altIdDomain": "operaonvideo.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.operaonvideo.com/?page_id={0}"
  },
  {
    "name": "OpusData",
    "altIdDomain": "opusdata.com/movie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://opusdata.com/movie/{0}"
  },
  {
    "name": "ORCID",
    "altIdDomain": "orcid.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://orcid.org/{0}"
  },
  {
    "name": "Google Play",
    "altIdDomain": "play.google.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://play.google.com/store/movies/details?id={0}"
  },
  {
    "name": "PORT.hu",
    "altIdDomain": "port.hu",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://port.hu/jump/movie-{0}"
  },
  {
    "name": "Prisma",
    "altIdDomain": "prisma.de",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.prisma.de/{0}"
  },
  {
    "name": "Rotten Tomatoes",
    "altIdDomain": "rottentomatoes.com/season",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.rottentomatoes.com/tv/season/{0}"
  },
  {
    "name": "Salam Cinema",
    "altIdDomain": "salamcinama.ir",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.salamcinama.ir/movie/{0}/"
  },
  {
    "name": "Scope",
    "altIdDomain": "scope.dk",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.scope.dk/film.php?id={0}"
  },
  {
    "name": "Screen Australia",
    "altIdDomain": "screenaustralia.gov.au",
    "ui": true,
    "mediaType": "application/json",
    "uriTemplate": "https://screenaustralia.external.gyde.tv/titles/{0}.json"
  },
  {
    "name": "Seecinema",
    "altIdDomain": "seecinema.net",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.seecinema.net/single_movie.php?film_id={0}"
  },
  {
    "name": "SensaCine Mexico",
    "altIdDomain": "sensacine.com.mx/peliculas",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.sensacine.com.mx/peliculas/pelicula-{0}/"
  },
  {
    "name": "SensaCine Mexico Series",
    "altIdDomain": "sensacine.com.mx/series",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.sensacine.com.mx/series/serie-{0}/"
  },
  {
    "name": "SensaCine Peliculas",
    "altIdDomain": "sensacine.com/peliculas",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.sensacine.com/peliculas/pelicula-{0}/"
  },
  {
    "name": "SensaCine Series",
    "altIdDomain": "sensacine.com/series",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.sensacine.com/series/serie-{0}/"
  },
  {
    "name": "Svensk Filmdatabas",
    "altIdDomain": "sfi.se",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.svenskfilmdatabas.se/sv/item/?type=film&itemid={0}"
  },
  {
    "name": "sfu.sk",
    "altIdDomain": "sfu.sk",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.kino-lumiere.sk/klient-863/kino-241/stranka-8409/film-{0}/"
  },
  {
    "name": "Siamzone",
    "altIdDomain": "siamzone.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.siamzone.com/movie/m/{0}"
  },
  {
    "name": "Sinemalar",
    "altIdDomain": "sinemalar.com/dizi",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.sinemalar.com/dizi/{0}"
  },
  {
    "name": "Sinemalar",
    "altIdDomain": "sinemalar.com/film",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.sinemalar.com/film/{0}"
  },
  {
    "name": "Sinematurk",
    "altIdDomain": "sinematurk.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.sinematurk.com/film/{0}"
  },
  {
    "name": "Soureh Cinema",
    "altIdDomain": "sourehcinema.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.sourehcinema.com/Title/Title.aspx?id={0}"
  },
  {
    "name": "Swiss Films",
    "altIdDomain": "swissfilms.ch",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.swissfilms.ch/de/film_search/filmdetails/-/id_film/{0}"
  },
  {
    "name": "tainiothiki.gr",
    "altIdDomain": "tainiothiki.gr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.tainiothiki.gr/v2/lang_el/filmography/view/{0}/"
  },
  {
    "name": "tainiothiki.gr",
    "altIdDomain": "tainiothiki.gr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.tainiothiki.gr/v2/lang_en/filmography/view/{0)/"
  },
  {
    "name": "tainiothiki.gr",
    "altIdDomain": "tainiothiki.gr",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.tainiothiki.gr/v2/lang_fr/filmography/view/{0}/"
  },
  {
    "name": "Taiwan Cinema",
    "altIdDomain": "taiwancinema.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.taiwancinema.com/EngFilm/EngFilmcontent/?ContentUrl={0}"
  },
  {
    "name": "Trinity College Dublin",
    "altIdDomain": "tcd.ie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.tcd.ie/irishfilm/showfilm.php?fid={0}"
  },
  {
    "name": "Turner Classic Movies",
    "altIdDomain": "tcm.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.tcm.com/tcmdb/title/{0}/movie"
  },
  {
    "name": "telecineplay.com.br",
    "altIdDomain": "telecineplay.com.br",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://telecineplay.com.br/filme/{0}"
  },
  {
    "name": "The Numbers",
    "altIdDomain": "the-numbers.com/movie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://the-numbers.com/movie/{0}"
  },
  {
    "name": "The Futon Critic",
    "altIdDomain": "thefutoncritic.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.thefutoncritic.com/showatch/{0}/"
  },
  {
    "name": "The Movie DB",
    "altIdDomain": "themoviedb.org/movie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.themoviedb.org/movie/{0}"
  },
  {
    "name": "The Movie DB",
    "altIdDomain": "themoviedb.org/tv",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.themoviedb.org/tv/{0}"
  },
  {
    "name": "The TV DB",
    "altIdDomain": "thetvdb.com/episodes",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.thetvdb.com/dereferrer/episode/{0}"
  },
  {
    "name": "TVDB Movie",
    "altIdDomain": "thetvdb.com/movies",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.thetvdb.com/dereferrer/movie/{0}"
  },
  {
    "name": "TheTVDB.com",
    "altIdDomain": "thetvdb.com/series",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.thetvdb.com/?tab=series&id={0}"
  },
  {
    "name": "tib.eu",
    "altIdDomain": "tib.eu",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://doi.org/{0}"
  },
  {
    "name": "Tower Japan",
    "altIdDomain": "tower.jp",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://tower.jp/item/{0}/"
  },
  {
    "name": "Tubi",
    "altIdDomain": "tubitv.com/series",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://tubitv.com/series/{0}"
  },
  {
    "name": "Turkce Altyazı",
    "altIdDomain": "turkcealtyazi.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.turkcealtyazi.org/mov/{0}/"
  },
  {
    "name": "Apple TV+ Episode",
    "altIdDomain": "tv.apple.com/episode",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://tv.apple.com/episode/{0}"
  },
  {
    "name": "Apple TV+ Movie",
    "altIdDomain": "tv.apple.com/movie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://tv.apple.com/movie/{0}"
  },
  {
    "name": "Apple TV+ Show",
    "altIdDomain": "tv.apple.com/show",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://tv.apple.com/show/{0}"
  },
  {
    "name": "TV.com Episode",
    "altIdDomain": "tv.com/episode",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.tv.com/episode/{0}/summary.html"
  },
  {
    "name": "TV.com Show",
    "altIdDomain": "tv.com/show",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "http://www.tv.com/show/{0}/summary.html"
  },
  {
    "name": "Rakuten TV",
    "altIdDomain": "tv.rakuten.co.jp",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://tv.rakuten.co.jp/content/{0}/"
  },
  {
    "name": "TV Guide",
    "altIdDomain": "tvguide.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.tvguide.com/detail/tv-show.aspx?tvobjectid={0}"
  },
  {
    "name": "TV Maze",
    "altIdDomain": "tvmaze.com/episodes",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://tvmaze.com/episodes/{0}"
  },
  {
    "name": "TV Maze",
    "altIdDomain": "tvmaze.com/episodes",
    "ui": false,
    "mediaType": "application/json",
    "uriTemplate": "https://api.tvmaze.com/episodes/{0}"
  },
  {
    "name": "TV Maze",
    "altIdDomain": "tvmaze.com/seasons",
    "ui": false,
    "mediaType": "application/json",
    "uriTemplate": "https://api.tvmaze.com/seasons/{0}"
  },
  {
    "name": "TV Maze",
    "altIdDomain": "tvmaze.com/shows",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.tvmaze.com/shows/{0}"
  },
  {
    "name": "TV Maze",
    "altIdDomain": "tvmaze.com/shows",
    "ui": false,
    "mediaType": "application/json",
    "uriTemplate": "https://api.tvmaze.com/shows/{0}"
  },
  {
    "name": "TV Meter",
    "altIdDomain": "tvmeter.nl/season",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.tvmeter.nl/season/{0}"
  },
  {
    "name": "TV Meter",
    "altIdDomain": "tvmeter.nl/show",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.tvmeter.nl/show/{0}"
  },
  {
    "name": "UniFrance Films",
    "altIdDomain": "unifrance.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.unifrance.org/film/{0}"
  },
  {
    "name": "VIAF",
    "altIdDomain": "viaf.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://viaf.org/viaf/{0}/"
  },
  {
    "name": "VideoDetective",
    "altIdDomain": "videodetective.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.videodetective.com?publishedid={0}"
  },
  {
    "name": "Vimeo",
    "altIdDomain": "vimeo.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://vimeo.com/{0}"
  },
  {
    "name": "Vivo Play",
    "altIdDomain": "vivoplay.com.br/movie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.vivoplay.com.br/details/movie/{0}"
  },
  {
    "name": "Vivo Play",
    "altIdDomain": "vivoplay.com.br/serie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.vivoplay.com.br/details/serie/{0}"
  },
  {
    "name": "Vtape",
    "altIdDomain": "vtape.org/video",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://vtape.org/video?vi={0}"
  },
  {
    "name": "Vudu",
    "altIdDomain": "vudu.com/MTID",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.vudu.com/movies/#!content/{0}"
  },
  {
    "name": "Walmart",
    "altIdDomain": "walmart.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.walmart.com/ip/{0}"
  },
  {
    "name": "Wavelength",
    "altIdDomain": "wavelengthpublicmedia.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://wavelengthpublicmedia.org/video/?ProjectId={0}"
  },
  {
    "name": "AlloCine Film",
    "altIdDomain": "webedia-group.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.allocine.fr/film/fichefilm_gen_cfilm={0}.html"
  },
  {
    "name": "AlloCine Film",
    "altIdDomain": "webedia-group.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.adorocinema.com/filmes/filme-{0}/"
  },
  {
    "name": "AlloCine Film",
    "altIdDomain": "webedia-group.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.beyazperde.com/filmler/film-{0}/"
  },
  {
    "name": "AlloCine Film",
    "altIdDomain": "webedia-group.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.filmstarts.de/kritiken/{0}.html"
  },
  {
    "name": "AlloCine Film",
    "altIdDomain": "webedia-group.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.sensacine.com/peliculas/pelicula-{0}/"
  },
  {
    "name": "AlloCine Film",
    "altIdDomain": "webedia-group.com",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.sensacine.com.mx/peliculas/pelicula-{0}/"
  },
  {
    "name": "Wikidata",
    "altIdDomain": "wikidata.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.wikidata.org/wiki/{0}"
  },
  {
    "name": "Wikidata",
    "altIdDomain": "wikidata.org",
    "ui": false,
    "mediaType": "application/json",
    "uriTemplate": "https://www.wikidata.org/wiki/Special:EntityData/{0}.json"
  },
  {
    "name": "Wikidata",
    "altIdDomain": "wikidata.org",
    "ui": false,
    "mediaType": "application/rdf",
    "uriTemplate": "https://www.wikidata.org/wiki/Special:EntityData/{0}.rdf"
  },
  {
    "name": "Wikidata",
    "altIdDomain": "wikidata.org",
    "ui": false,
    "mediaType": "application/ttl",
    "uriTemplate": "https://www.wikidata.org/wiki/Special:EntityData/{0}.ttl"
  },
  {
    "name": "Wikidata",
    "altIdDomain": "wikidata.org",
    "ui": false,
    "uriTemplate": "https://www.wikidata.org/wiki/Special:EntityData/{0}",
    "doesContentNegotiation": true
  },
  {
    "name": "OCLC",
    "altIdDomain": "worldcat.org",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.worldcat.org/oclc/{0}"
  },
  {
    "name": "Wunschliste",
    "altIdDomain": "wunschliste.de/episode",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.wunschliste.de/episode/{0}"
  },
  {
    "name": "Wunschliste",
    "altIdDomain": "wunschliste.de/serie",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.wunschliste.de/links.pl?s={0}"
  },
  {
    "name": "American Film Institute",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://catalog.afi.com/Catalog/moviedetails/{0}",
    "altIdType": "AFI"
  },
  {
    "name": "All Music Guide",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.allmovie.com/movie/{0}/cast-crew",
    "altIdType": "AMG"
  },
  {
    "name": "British Film Institute",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://collections-search.bfi.org.uk/web/Details/ChoiceFilmWorks/{0}",
    "altIdType": "BFI"
  },
  {
    "name": "DOI",
    "ui": true,
    "uriTemplate": "https://doi.org/{0}",
    "altIdType": "DOI"
  },
  {
    "name": "EIDR",
    "ui": false,
    "mediaType": "text/html",
    "uriTemplate": "https://ui.eidr.org/view/content?id={0}",
    "altIdType": "EIDR"
  },
  {
    "name": "EIDR",
    "ui": false,
    "mediaType": "application/xml",
    "uriTemplate": "https://doi.org/{0}",
    "altIdType": "EIDR"
  },
  {
    "name": "IMDb",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.imdb.com/title/{0}",
    "altIdType": "IMDB"
  },
  {
    "name": "ISAN",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://www.isan.org/lookup/{0}",
    "altIdType": "ISAN"
  },
  {
    "name": "ISRC",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://isrcsearch.ifpi.org/#!/search?isrcCode={0}&tab=lookup&showReleases=0&start=0&number=10",
    "altIdType": "ISRC"
  },
  {
    "name": "Lumiere",
    "ui": true,
    "mediaType": "text/html",
    "uriTemplate": "https://lumiere.obs.coe.int/web/film_info/?id={0}",
    "altIdType": "Lumiere"
  },
  {
    "name": "ShortDOI",
    "ui": true,
    "uriTemplate": "https://doi.org/{0}",
    "altIdType": "ShortDOI"
  }
];